export const SET_FROM_SEARCH_OFFER = 'SET_FROM_SEARCH_OFFER';
